/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Style_Toggle_ShowInputs */

const en_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show Subtitle Styling`)
};

const fr_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le style des sous-titres`)
};

const de_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitelformatierung anzeigen`)
};

const it_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra stile sottotitoli`)
};

const ru_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать стиль субтитров`)
};

const es_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar estilo de subtítulos`)
};

const zh_cn2_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示字幕样式`)
};

const ja_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕スタイルを表示`)
};

const hi_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक शैली दिखाएँ`)
};

const pt_pt2_video_export_style_toggle_show = /** @type {(inputs: Video_Export_Style_Toggle_ShowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exibir estilo de legenda`)
};

/**
* | output |
* | --- |
* | "Show Subtitle Styling" |
*
* @param {Video_Export_Style_Toggle_ShowInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_style_toggle_show = /** @type {((inputs?: Video_Export_Style_Toggle_ShowInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Style_Toggle_ShowInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_video_export_style_toggle_show(inputs)
	if (locale === "de") return de_video_export_style_toggle_show(inputs)
	if (locale === "it") return it_video_export_style_toggle_show(inputs)
	if (locale === "ru") return ru_video_export_style_toggle_show(inputs)
	if (locale === "es") return es_video_export_style_toggle_show(inputs)
	if (locale === "zh-CN") return zh_cn2_video_export_style_toggle_show(inputs)
	if (locale === "ja") return ja_video_export_style_toggle_show(inputs)
	if (locale === "hi") return hi_video_export_style_toggle_show(inputs)
	if (locale === "pt-PT") return pt_pt2_video_export_style_toggle_show(inputs)
	return en_video_export_style_toggle_show(inputs)
});